import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { setRiderItemToEdit, setRiderModal, setShoeingItemToEdit, setShoeingModal, setTrainingTypeModal, setTrainingTypeToEdit } from '../../store/reducers/modal.reducer'
import { Box, Grid, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import { LoadingButton } from '@mui/lab'
import { SubmitHandler, useForm } from 'react-hook-form'
import { TShoeing } from '../../shared/types/shoeing.type'
import { get, isEqual, toNumber, update } from 'lodash'
import { TUser } from '../../shared/types/user.type'
import { useRiders } from '../../hooks/useRiders'
import { TRider } from '../../shared/types/rider.type'
import { TTrainingType } from '../../shared/types/training.type'
import { UseTrainingType } from '../../hooks/useTrainingType'
import { useQueryClient } from 'react-query'

function TrainingTypeModal() {
    const open = useSelector<RootState>(state => state.modals.trainingtypeModal) as boolean
    const itemToEdit = useSelector<RootState>(state => state.modals.trainingTypeToEdit, isEqual) as TTrainingType | null
    const auth = useSelector<RootState>(state => state.user.user) as TUser | null
    const { create, update, isCreating, isUpdating } = UseTrainingType(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (itemToEdit) {
            setValue('id', itemToEdit.id)
            setValue('name', itemToEdit?.name)
        }
    }, [itemToEdit])

    const {
        register,
        handleSubmit,
        reset,
        setValue,

        formState: { errors, touchedFields },
    } = useForm<Partial<TTrainingType>>({
    })

    const onSubmit: SubmitHandler<Partial<TTrainingType>> = (data) => {
        const tData: Partial<TTrainingType> =
        {
            ...data,
            trainer: get(auth, '@id')
        }
        console.log({});

        let promise = itemToEdit ? update(tData) : create(tData)

        promise
            .then(() => {
                //On Success reset Form
                reset()
                dispatch(setTrainingTypeToEdit(null))
                dispatch(setTrainingTypeModal(false))
            }).catch(err => { })
    }
    if(!open) return null

    return (
        <BaseModal title={itemToEdit ? 'tracks:information' : 'newTrainingType'} open={open} handleClose={() => {
            dispatch(setTrainingTypeModal(false))
            dispatch(setTrainingTypeToEdit(null))
            reset()
        }}>
            <Box>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Grid container spacing={3}>

                        <Grid item md={12} xs={12}>
                            <TextField error={errors?.hasOwnProperty('name')} {...register('name', { required: true })} fullWidth label={t('equimetre:table:name')}></TextField>
                        </Grid>
                    </Grid>
                    <Box display={'flex'} mt={2} justifyContent={'end'}>
                        <LoadingButton loading={isCreating || isUpdating} type='submit' variant='contained'>{itemToEdit ? t('button:edit') : t('button:save')}</LoadingButton>
                    </Box>
                </form>
            </Box>

        </BaseModal>
    )
}

export default TrainingTypeModal